const appLayoutReducer = (state, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default appLayoutReducer;
